"use strict";

class NeptuneRecentlyViewed {
  constructor() {
    this.storageKey = 'neptune_recently_viewed';
    this.maxProducts = 12;
    this.carousel = null;
    this.debug = false;
    this.init();
  }
  init() {
    this.trackCurrentProduct();
    this.loadRecentlyViewedProducts();
  }
  trackCurrentProduct() {
    if (window.location.pathname.includes('/products/')) {
      const productHandle = this.getProductHandleFromUrl();
      if (productHandle) {
        this.addProduct(productHandle);
      }
    }
  }
  getProductHandleFromUrl() {
    const pathParts = window.location.pathname.split('/');
    const productIndex = pathParts.indexOf('products');
    if (productIndex !== -1 && pathParts[productIndex + 1]) {
      return pathParts[productIndex + 1];
    }
    return null;
  }
  addProduct(productHandle) {
    if (!productHandle) return;
    let recentlyViewed = this.getRecentlyViewed();
    recentlyViewed = recentlyViewed.filter(handle => handle !== productHandle);
    recentlyViewed.unshift(productHandle);
    if (recentlyViewed.length > this.maxProducts) {
      recentlyViewed = recentlyViewed.slice(0, this.maxProducts);
    }
    this.saveRecentlyViewed(recentlyViewed);
    if (this.debug) {}
  }
  getRecentlyViewed() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      return [];
    }
  }
  saveRecentlyViewed(products) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(products));
    } catch (error) {}
  }
  async fetchProductHTML(productHandle, aspectRatio = 'natural') {
    try {
      const response = await fetch(`/products/${productHandle}?view=item&aspect_ratio=${aspectRatio}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.text();
    } catch (error) {
      return null;
    }
  }
  async loadRecentlyViewedProducts() {
    if (window.location.port.length > 0 || window.location.href.indexOf("product-recommendations-recently-viewed=off") != -1) {
      return;
    }
    const section = document.querySelector('[data-section-type="product-recommendations-recently-viewed"]');
    if (!section) return;
    const carousel = section.querySelector('.carousel__slides');
    if (!carousel) return;
    const aspectRatio = section.dataset.aspectRatio || 'natural';
    const recentlyViewed = this.getRecentlyViewed();
    const currentProductHandle = this.getProductHandleFromUrl();
    const productsToShow = recentlyViewed.filter(handle => handle !== currentProductHandle);
    if (productsToShow.length === 0) {
      if (this.debug) {}
      section.style.display = 'none';
      return;
    }
    if (this.debug) {}
    carousel.innerHTML = '<div class="recently-viewed-loading">Loading recently viewed products...</div>';
    try {
      const productPromises = productsToShow.map(handle => this.fetchProductHTML(handle, aspectRatio));
      const productHTMLs = await Promise.all(productPromises);
      const validProducts = productHTMLs.filter(html => html !== null && html.indexOf("<!doctype html>") == -1);
      if (validProducts.length === 0) {
        section.style.display = 'none';
        return;
      }
      carousel.innerHTML = validProducts.map(html => `<div class="carousel__slide">${html}</div>`).join('');
      section.style.display = '';
      this.initializeCarousel(section);
    } catch (error) {
      section.style.display = 'none';
    }
  }
  initializeCarousel(section) {
    const initCarousel = () => {
      if (window.theme && typeof window.theme.carousel === 'function') {
        if (this.carousel) {
          this.carousel.unload();
          this.carousel = null;
        }
        this.carousel = window.theme.carousel(section);
        if (this.debug) {}
        section.dispatchEvent(new CustomEvent('recentlyViewed:loaded', {
          detail: {
            section,
            carousel: this.carousel
          }
        }));
      } else {
        setTimeout(initCarousel, 100);
      }
    };
    initCarousel();
  }
  clearRecentlyViewed() {
    localStorage.removeItem(this.storageKey);
    if (this.carousel) {
      this.carousel.unload();
      this.carousel = null;
    }
    const section = document.querySelector('[data-section-type="product-recommendations-recently-viewed"]');
    if (section) {
      section.style.display = 'none';
    }
  }
  destroy() {
    if (this.carousel) {
      this.carousel.unload();
      this.carousel = null;
    }
  }
}
document.addEventListener('DOMContentLoaded', () => {
  const initRecentlyViewed = () => {
    if (window.NeptuneRecentlyViewed) return;
    if (window.theme) {
      window.NeptuneRecentlyViewed = new NeptuneRecentlyViewed();
    } else {
      setTimeout(initRecentlyViewed, 50);
    }
  };
  initRecentlyViewed();
});
window.NeptuneRecentlyViewedClass = NeptuneRecentlyViewed;